import { render, staticRenderFns } from "./media_planning.vue?vue&type=template&id=8724e8c6&scoped=true"
import script from "./media_planning.vue?vue&type=script&lang=js"
export * from "./media_planning.vue?vue&type=script&lang=js"
import style0 from "./media_planning.vue?vue&type=style&index=0&id=8724e8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8724e8c6",
  null
  
)

export default component.exports